<template>
  <div
    :class="{[getCss('default')]: !styles.image || !styles.image.src , 'csu-clickable': clickable}"
    :style="{...wrapStyle}"
    @click="handleClickEvent()"
    @mouseenter="handleEvent('hover')"
    v-if="isShow"
  >
    <img
      v-if="styles.image.src"
      :class="[styles.image.equalScale ? getCss('contain') : getCss('fill')]"
      v-src="styles.image.src"
      width="100%"
      height="100%"
      :alt="styles.image.alt"
      :style="animateStyle"
    />
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import {componentBaseMixin} from '@tencent/ceiba-base-components';

export default {
  name: 'CImage',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'image-',
      classKeys: [
        'default',
        'contain',
        'fill',
      ],
    };
  },
  computed: {
    wrapStyle() {
      if (this.configurationData?.needPenetrate) {
        return {
          "pointer-events": "none",
          ...this.styles.base,
        };
      }
      return {
        ...this.styles.base,
      };
    },
    animateStyle() {
      return Object.assign({}, this.styles.animate);
    },
    isShow() {
      let time = this.configurationData?.showTime
      if (time) {
        if (this.$platform.isIos) {
          time = time.replace(/-/g, '/');
        }
        time = new Date(time).getTime();
        const timeNow = new Date().getTime();
        if (timeNow > time) {
          return true
        } else {
          return false
        }
      }
      return true
    }
  },
  methods: {},
};
</script>
<style lang="scss">
@import './image.scss';
</style>
